'use client';

import { usePortalContext } from '@cloai/uikit';
import { useTranslations } from 'next-intl';
import { SyntheticEvent, FC, memo, useState, useEffect, useRef } from 'react';

import { SeeAllButton } from '@/src/components/SeeAllButton';
import { useInView } from '@/src/hooks/useInView';
import { useStyleContext } from '@/src/providers';
import { PORTALS } from '@/.constants/portals';

const styles = {
  wrapper: 'flex flex-col gap-3',
  styleItem: 'w-full relative overflow-hidden rounded-lg content-visible',
  preview:
    'w-full h-auto aspect-square object-cover object-top pointer-events-none',
  line: 'flex items-center gap-2 justify-between',
  lineTitle: 'text-lg font-bold',
};

export const Effects: FC = memo(() => {
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const t = useTranslations('MenuPage');
  const [hasStarted, setHasStarted] = useState(false);
  const [refForPlay, isInViewport] = useInView<HTMLButtonElement>({
    rootMargin: '0px',
    threshold: 0.1,
  });
  const { openPortal } = usePortalContext();
  const { setPrevPortal, setPortalSeeAllMode, changeActiveCategory } =
    useStyleContext();
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleClickImage = (event: SyntheticEvent) => {
    setPrevPortal('main');
    changeActiveCategory('01K8NM7GFG3N8D3FD0BT89QEB3', 'effects'); // ведем на Популярные эффекты
    setPortalSeeAllMode('effectsCategories');
    openPortal(PORTALS.SeeAllImages);
  };

  useEffect(() => {
    if (!hasStarted && isInViewport && videoRef.current) {
      videoRef.current.play().catch();
      setHasStarted(true);
    }
  }, [isInViewport, hasStarted]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.line}>
        <div className={styles.lineTitle}>{t('effectsTitle')}</div>
        <SeeAllButton onClick={handleClickImage} />
      </div>
      <button
        ref={refForPlay}
        className={styles.styleItem}
        onClick={handleClickImage}
      >
        {!mediaLoaded && (
          <div className="absolute z-10 inset-0 animate-skeleton-pulse"></div>
        )}
        <video
          ref={videoRef}
          preload="metadata"
          // autoPlay
          loop
          muted
          playsInline
          className={styles.preview}
          onLoadedData={() => setMediaLoaded(true)}
        >
          <source type="video/mp4" src="/images/effects_new.mp4" />
        </video>
      </button>
    </div>
  );
});

Effects.displayName = 'Effects';
